import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import MediaQuery from "react-responsive";

import { withRouter } from "react-router-dom";
import DashboardSectionTabs from "./DashboardSectionTabs";
import DashboardSliderTabs from "../DashboardSliderTabs";
import { WithholdingTaxDiscovery } from "../../sections/Sales/WithholdingTaxDiscovery";
class DashboardTabbedSection extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onTabChange: PropTypes.func,
    renderHeaderActions: PropTypes.func,
  };

  static contextTypes = {
    router: PropTypes.shape({
      history: PropTypes.shape({
        push: PropTypes.func.isRequired,
      }).isRequired,
    }).isRequired,
  };

  state = {
    index: 0,
  };

  componentWillMount() {
    this.setActiveTab(this.getActiveTabIndex());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      const newIndex = this.getActiveTabIndex();
      const tabs = this.getTabs();
      if (newIndex !== this.state.index && tabs[newIndex]) {
        this.setState({ index: newIndex });
      }
    }
  }

  getTabs() {
    return React.Children.toArray(this.props.children);
  }

  matchPath(path) {
    const { route } = this.context.router;
    const to =
      path && path !== "/" ? route.match.url + "/" + path : route.match.url;
    return route.location.pathname.startsWith(to);
  }

  getActiveTabIndex() {
    const tabs = this.getTabs();
    const activeTab = tabs.findIndex((tab) => this.matchPath(tab.props.path));
    if (activeTab < 0) {
      const defaultTab = tabs.findIndex((tab) => tab.props.default);
      return defaultTab < 0 ? 0 : defaultTab;
    }
    return activeTab;
  }

  setActiveTab(index) {
    const tabs = this.getTabs();
    const activeTab = tabs[index];
    const { history, route } = this.context.router;
    const {
      location: { pathname },
    } = this.props;

    const lastParam = pathname.split("/").pop();

    const to =
      activeTab.props.path && activeTab.props.path !== "/"
        ? route.match.url + "/" + activeTab.props.path
        : route.match.url;

    if (!Number(lastParam)) {
      history.push(to);
    }

    this.setState({ index });
    this.props.onTabChange && this.props.onTabChange(index);
  }

  getActiveTabContent(tabs) {
    const activeTabIndex = this.getActiveTabIndex();
    const tabIndex = activeTabIndex >= 0 ? activeTabIndex : this.state.index;
    return tabs[tabIndex] || tabs[0];
  }

  render() {
    const tabs = this.getTabs();
    const { className, renderHeaderActions } = this.props;
    const activeTabIndex = this.getActiveTabIndex();
    const activeTabContent = this.getActiveTabContent(tabs);

    return (
      <div className={classNames("dashboard-section", className)}>
        <div className="dashboard-section-header">
          <div className="dashboard-section-header-tabs">
            <MediaQuery query="(max-width: 555px)">
              <DashboardSliderTabs
                defaultTab={activeTabIndex}
                onChange={(tabIndex) => this.setActiveTab(tabIndex)}
                tabs={tabs.map((tab) => ({ title: tab.props.title }))}
              />
            </MediaQuery>
            <MediaQuery query="(min-width: 556px)">
              <DashboardSectionTabs
                defaultTab={activeTabIndex}
                onChange={(tabIndex) => this.setActiveTab(tabIndex)}
                tabs={tabs.map((tab) => ({ title: tab.props.title }))}
              />
            </MediaQuery>
          </div>
          {renderHeaderActions && (
            <div
              className="dashboard-section-header-actions"
              data-testid="recurring-payments-header-actions"
            >
              {renderHeaderActions(activeTabIndex)}
            </div>
          )}
        </div>

        <div className="dashboard-section-body">
          <div className="dashboard-section-content">{activeTabContent}</div>
        </div>
        <WithholdingTaxDiscovery />
      </div>
    );
  }
}


export default withRouter(DashboardTabbedSection);
